// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"480":"8081a3e0","8506":"1e9af53c","9173":"aaf94c70"}[chunkId] + ".chunk.css";
};